import { useSafeAreaInsets, useSafeAreaFrame } from 'react-native-safe-area-context';

export const useBottomOffset = (heightMultiplier, safeHeightMultiplier) => {
  const { height } = useSafeAreaFrame();
  const insets = useSafeAreaInsets();
  const safeHeight = height - insets.top - insets.bottom;

  return heightMultiplier * height + safeHeightMultiplier * safeHeight;
};
